//
import cargosMachine from "./machine"
import { actionsNoCare } from "../../constants/actionsNoCare"
export const { initialState } = cargosMachine

const Cargos = (state = initialState, action) => {
  //
  if (
    !actionsNoCare.includes(action.type) &&
    !action.type.startsWith("@@") &&
    action.type.startsWith("cargos/")
  ) {
    if (!cargosMachine.states[state.value]?.on?.[action.type]) {
      console.error(
        `cargosMachine: No hay transición definida para la acción ${action.type} en el estado ${state.value}`
      )
    } else {
      return cargosMachine.transition(state, action)
    }
  }
  return state
}

export default Cargos
